import React from "react";

import classes from "./Profile.module.css";

const Profile = (props) => {
    let profile = null;
    if (props.userProfile) {
        profile = (
            <div className={classes.Container}>
                <div className={classes.Row}>
                    <p>Profile picture</p>
                    <img src={props.userProfile.profile_picture} alt ='Profile pic'/>
                </div>
                <div className={classes.Row}>
                    <p>Name</p>
                    <p className={classes.infoColor}>{props.userProfile.name}</p>
                </div>
                <div className={classes.Row}>
                    <p>E-mail</p>
                    <p className={classes.infoColor}>{props.userProfile.email}</p>
                </div>
                
                <div className={classes.Row}>
                    <p>UserName</p>
                    <p className={classes.infoColor}>{props.userProfile.username}</p>
                </div>
                <div className={`${classes.Row} ${classes.NoBorder}`}>
                    <p>Phone</p>
                    <p className={classes.infoColor}>{props.userProfile.phone}</p>
                </div>
                <button 
                type='button' 
                className={classes.Btn}
                onClick={()=>{
                    props.showEditeUserFormHandler()
                }}>Edit my profile</button>
            </div>
        );
    }
    return (
        profile
    )
};

export default Profile;